import './ExpenseTransactions.css';
import React from 'react';
import { createDollarFormatter, createNumberFormatter, createLinkFormatter, dateRangeFilterEditor, minMaxFilterFunction } from './TableUtils.js';
import './TableUtils.css';
import { useSearchParams } from "react-router-dom";

import 'react-tabulator/lib/styles.css';
import 'react-tabulator/lib/css/tabulator.min.css';
import { ReactTabulator } from 'react-tabulator';

function searchParamsToFilter(searchParams) {
  const filters = {};
  searchParams.forEach((value, key) => {
    if (key === "spending_category" || key === "top_level_category" || key === "account" || key === "symbol" || key === "type") {
      filters[key] = { field: key, value: value, type: "=" };
    } else if (key === "note") {
      filters[key] = { field: key, value: value, type: "like" };
    } else if (key === "start") {
      const existing = filters["day"] || { field: "day", value: {}, type: "function" };
      existing.value.start = value;
      filters["day"] = existing;
    } else if (key === "end") {
      const existing = filters["day"] || { field: "day", value: {}, type: "function" };
      existing.value.end = value;
      filters["day"] = existing;
    }
  });
  const result = [];
  for (var key in filters) {
    result.push(filters[key]);
  }
  return result;
}

function filterToSearchParams(filters) {
  const result = {};
  filters.forEach((row) => {
    if (row.field === "spending_category" || row.field === "top_level_category" || row.field === "account" || row.field === "symbol" || row.field === "type" || row.field === "note") {
      if (row.value) result[row.field] = row.value;
    } else if (row.field === "day") {
      if (row.value && row.value.start) result["start"] = row.value.start;
      if (row.value && row.value.end) result["end"] = row.value.end;
    }
  });
  return result;
}

function tabulatorUrlParams(params, prefix) {
  var parts = [];
  for (var key in params) {
    var value = params[key];
    var fullKey = prefix ? prefix + "[" + key + "]" : key;
    if (typeof value === "object" && value !== null) {
      parts.push(tabulatorUrlParams(value, fullKey));
    } else {
      parts.push(encodeURIComponent(fullKey) + "=" + encodeURIComponent(value));
    }
  }
  return parts.filter(Boolean).join("&");
}

const _expTxnAjaxCache = new Map();

function cachedAjaxRequestFunc(url, config, params) {
  var queryString = tabulatorUrlParams(params);
  var fullUrl = queryString ? url + '?' + queryString : url;
  if (_expTxnAjaxCache.has(fullUrl)) {
    return Promise.resolve(_expTxnAjaxCache.get(fullUrl));
  }
  return fetch(fullUrl)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      _expTxnAjaxCache.set(fullUrl, data);
      return data;
    });
}

export const loader = async () => {
  return {};
};

function ExpenseTransactions() {
  const [searchParams] = useSearchParams();

  const columns = [
    { title: "day", field: "day", headerSortStartingDir: "desc", sorter: "date", headerFilter: dateRangeFilterEditor, headerFilterFunc: minMaxFilterFunction, headerFilterLiveFilter: false, minWidth: 320 },
    { title: "account", field: "account", headerFilter: "input", headerFilterFunc: "=", minWidth: 150 },
    { title: "symbol", field: "symbol", headerFilter: "input", headerFilterFunc: "=", minWidth: 80 },
    { title: "quantity", field: "quantity", sorter: "number", formatter: createNumberFormatter(2), hozAlign: 'right', minWidth: 100 },
    { title: "value_usd", field: "value_usd", sorter: "number", formatter: createDollarFormatter(2), hozAlign: 'right', minWidth: 110 },
    { title: "top_category", field: "top_level_category", headerFilter: "input", headerFilterFunc: "=", minWidth: 130 },
    { title: "category", field: "spending_category", headerFilter: "input", headerFilterFunc: "=", minWidth: 150 },
    { title: "note", field: "note", headerFilter: "input", minWidth: 200 },
    { title: "recording_account", field: "recording_account", headerFilter: "input", headerFilterFunc: "=", minWidth: 150 },
    { title: "id", field: "id",
      formatter: createLinkFormatter((cell) => {
        const rawTxnId = String(cell.getValue()).split('|')[0];
        return `/raw_transaction/${rawTxnId}`;
      }),
    },
  ];

  const initialFilter = searchParamsToFilter(searchParams);

  const options = {
    ajaxURL: (process.env.NODE_ENV === 'development' ? '/expense_transactions.json' : '/expense_transactions'),
    ajaxRequestFunc: cachedAjaxRequestFunc,
    ajaxResponse: (url, params, response) => { return response; },
    ajaxError: function (error) { console.log('ajaxError', error); },
    pagination: true,
    paginationMode: 'remote',
    paginationSize: 50,
    sortMode: 'remote',
    initialSort: [
      { column: "day", dir: "desc" },
    ],
    filterMode: 'remote',
    initialHeaderFilter: initialFilter,
    layout: "fitDataStretch",
    height: "100%",
  };

  const dataFilteredHandler = (filters, rows) => {
    const newParams = filterToSearchParams(filters);
    const newSearch = new URLSearchParams(newParams).toString();
    const newHash = '#/expense_transactions' + (newSearch ? '?' + newSearch : '');
    if (window.location.hash !== newHash) {
      window.history.replaceState(null, '', newHash);
    }
  };

  return (
    <div className="expense-transactions">
      <ReactTabulator
        key={searchParams.toString()}
        options={options}
        columns={columns}
        events={{ dataFiltered: dataFilteredHandler }}
      />
    </div>
  );
}

export default ExpenseTransactions;
